<template>
    <spinner v-if="isLoading"></spinner>
    <transition name="fade">
        <div>
            <BreadCrumbs
                :breadCrumbs="breadCrumbs"
                :title="title"
                :back_title="back_title"
                :link="link"
            />
            <Modules
                :modules="modules"
            />
        </div>
    </transition>
</template>

<script>
import spinner from "../../components/Spinner";
import BreadCrumbs from "../../Page/BreadCrumbs";
import Modules from "../../Page/Modules";
import axios from "axios";


export default {
    name: "RequestPage",
    components: {
        spinner, BreadCrumbs, Modules
    },
    data() {
        return {
            isLoading: false,
            breadCrumbs: true,
            title: this.$t("module.categories"),
            back_title: this.$t("module.main_menu"),
            link: 'main',
            modules: [],
        }
    },
    created() {
        this.getSubModules();
    },
    methods: {
        async getSubModules(){
            try {
                this.isLoading = true;
                const config = {'headers': { 'Authorization': 'Bearer ' + this.$cookie.getCookie('token') }};
                const response = await axios.get('/api/admin/users/get/modules/request', config);
                this.modules = response.data.data.modules;
            } catch (e) {
                //this.$cookie.removeCookie('token');
                console.log(e);
            }finally {
                this.isLoading = false;
            }
        },
    }
}
</script>

<style scoped>

</style>
